import { render, staticRenderFns } from "./CalendarSidebar.vue?vue&type=template&id=c41e45a0&scoped=true&"
import script from "./CalendarSidebar.vue?vue&type=script&lang=js&"
export * from "./CalendarSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CalendarSidebar.vue?vue&type=style&index=0&id=c41e45a0&lang=scss&scoped=true&"
import style1 from "./CalendarSidebar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41e45a0",
  null
  
)

export default component.exports